/* ==========================================================================
   OMR SPORT — COVERFLOW DE LA HOME  (seccion product-block, setting omr_coverflow)
   Referencia de movimiento: section.store/pages/slider-2-pro (Swiper, effect coverflow,
   centeredSlides, loop). Aqui no se carga Swiper: la geometria 3D vive en
   assets/omr-coverflow.css y este archivo solo decide la posicion de cada tarjeta.

   Modelo: N tarjetas en circulo. `pos` es la posicion del carrusel en unidades de
   tarjeta (entera en reposo, fraccionaria mientras se arrastra). Cada tarjeta recibe
   --cf-o, su distancia con signo a la central (0, -1, 1, -2, ...), y --cf-abs, su valor
   absoluto. El CSS convierte eso en translate3d(%) y profundidad.

   DESLIZAR ES LA ENTRADA PRINCIPAL. Tres vias, todas con el carrusel pegado al dedo:
   - tactil   : eventos touch. Seguimiento en vivo y suelta con inercia (flick).
   - raton    : eventos pointer (solo mouse/pen). Arrastrar con el boton pulsado.
   - trackpad : evento wheel con deltaX (dos dedos en horizontal). Un gesto = una tarjeta.
   Teclado: flechas con el foco en el carrusel. Las flechas visibles son opcionales
   (setting omr_coverflow_arrows, apagado por defecto).

   Sin clones de DOM salvo cuando hay menos de MIN tarjetas (se repite la lista para que
   el aro se vea simetrico).

   Para desactivar: apagar el setting omr_coverflow en la seccion. Este archivo no se
   carga con el setting apagado.
   ========================================================================== */
(function () {
  'use strict';

  var MIN_SLIDES = 8;       /* para ver -3..+3 sin repetir vecinos inmediatos */
  var VISIBLE_LIMIT = 3.5;  /* |o| mayor que esto: oculta (is-far). .5 por el arrastre fraccionario */
  var PRELOAD_LIMIT = 4;    /* |o| hasta aqui: la imagen deja de ser diferida al interactuar */
  var AXIS_SLOP = 6;        /* px antes de decidir si el gesto es horizontal o vertical */
  var TAP_STEP = 0.1;       /* fraccion de tarjeta que basta para cambiar de una a otra */
  var FLICK_MS = 80;        /* cuanto "futuro" proyecta la velocidad al soltar: un flick normal = 1 tarjeta */
  var MAX_JUMP = 3;         /* tarjetas maximas por un solo gesto */
  var WHEEL_STEP = 40;      /* deltaX acumulado para pasar una tarjeta */
  var WHEEL_GAP = 120;      /* ms sin eventos = el trackpad solto la inercia */
  var CLICK_GUARD_MS = 400; /* tras arrastrar, el click que sigue no abre la ficha */

  function mod(a, n) { return ((a % n) + n) % n; }

  function OmrCoverflow(root) {
    this.root = root;
    this.stage = root.querySelector('.omr-cf__stage');
    this.prevBtn = root.querySelector('.omr-cf__arrow--prev');
    this.nextBtn = root.querySelector('.omr-cf__arrow--next');
    if (!this.stage) { return; }

    var originals = [].slice.call(this.stage.children);
    this.realCount = originals.length;
    if (this.realCount < 2) { root.classList.add('omr-cf--single'); return; }

    /* Etiquetas "k / n" para las tarjetas reales. */
    originals.forEach(function (slide, i) {
      slide.setAttribute('aria-label', (i + 1) + ' / ' + originals.length);
    });

    /* Aro corto: se repite la lista. Los duplicados no entran al arbol de accesibilidad
       ni al orden de tabulacion, igual que los clones de Swiper. */
    while (this.stage.children.length < MIN_SLIDES) {
      for (var c = 0; c < originals.length; c++) {
        var clone = originals[c].cloneNode(true);
        clone.removeAttribute('aria-label');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-omr-cf-clone', '');
        var link = clone.querySelector('a');
        if (link) { link.setAttribute('tabindex', '-1'); }
        this.stage.appendChild(clone);
      }
    }

    this.slides = [].slice.call(this.stage.children);
    this.offsets = [];
    this.pos = Math.min(1, this.slides.length - 1); /* initialSlide: 1, como la referencia */
    this.drag = null;
    this.clickBlockedUntil = 0;
    this.wheelAcc = 0;
    this.wheelLast = 0;
    this.wheelLocked = false;

    this.bind();

    /* Primer reparto SIN transicion: el HTML trae una posicion inicial aproximada (y si
       hubo que clonar, distinta), y sin esto las tarjetas barrerian el escenario al cargar. */
    this.slides.forEach(function (sl) { sl.classList.add('is-jump'); });
    this.layout(false);
    void this.stage.offsetWidth;
    this.slides.forEach(function (sl) { sl.classList.remove('is-jump'); });
    root.classList.add('omr-cf--ready');
  }

  /* Ancho de una tarjeta en px, para convertir desplazamiento del dedo en tarjetas. */
  OmrCoverflow.prototype.slideWidth = function () {
    var view = parseFloat(getComputedStyle(this.root).getPropertyValue('--cf-view'));
    if (!(view > 0)) { view = 4; }
    var w = this.stage.clientWidth / view;
    return w > 0 ? w : 300;
  };

  /* Salta `delta` tarjetas con animacion (flechas, teclado, trackpad). */
  OmrCoverflow.prototype.go = function (delta) {
    this.pos = mod(Math.round(this.pos) + delta, this.slides.length);
    this.layout(true);
  };

  /* Reparte --cf-o / --cf-abs desde `this.pos`. Una tarjeta que cruza de un extremo al
     otro del aro se coloca sin transicion (is-jump), para que no barra la pantalla
     pasando por el centro. */
  OmrCoverflow.prototype.layout = function (animate) {
    var n = this.slides.length;
    var half = n / 2;
    var jumped = [];
    var i, o, slide, prev, a, img;

    for (i = 0; i < n; i++) {
      o = mod(i - this.pos, n);
      if (o > half) { o -= n; }
      a = Math.abs(o);

      slide = this.slides[i];
      prev = this.offsets[i];
      if (prev !== undefined && Math.abs(o - prev) > half) { /* dio la vuelta por el otro extremo */
        if (animate) { slide.classList.add('is-jump'); jumped.push(slide); }
      }
      this.offsets[i] = o;

      slide.style.setProperty('--cf-o', o.toFixed(3));
      slide.style.setProperty('--cf-abs', a.toFixed(3));
      slide.classList.toggle('is-far', a > VISIBLE_LIMIT);
      slide.classList.toggle('is-center', a < 0.5);
      slide.style.zIndex = String(1000 - Math.round(a * 10)); /* entero: la central siempre encima */

      /* Al cargar manda el lazy nativo (la banda esta bajo el pliegue); al interactuar, las
         cercanas se piden ya para que no aparezcan en blanco al entrar. */
      if (animate && a <= PRELOAD_LIMIT) {
        img = slide.querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') { img.setAttribute('loading', 'eager'); }
      }
    }

    if (jumped.length) {
      void this.stage.offsetWidth; /* aplica el estado sin transicion antes de devolverla */
      jumped.forEach(function (s) { s.classList.remove('is-jump'); });
    }
  };

  /* ---- Arrastre: comun a touch y mouse ---------------------------------------------- */

  OmrCoverflow.prototype.dragStart = function (x, y) {
    this.drag = {
      x0: x, y0: y,
      pos0: this.pos,
      axis: null,        /* null = sin decidir, 'x' = horizontal, 'y' = vertical (se cede a la pagina) */
      active: false,
      samples: [{ x: x, t: Date.now() }]
    };
    this.clickBlockedUntil = 0;
  };

  /* Devuelve true si el gesto es horizontal y ya lo lleva el carrusel. */
  OmrCoverflow.prototype.dragMove = function (x, y) {
    var d = this.drag;
    if (!d || d.axis === 'y') { return false; }
    var dx = x - d.x0;
    var dy = y - d.y0;

    if (d.axis === null) {
      if (Math.abs(dx) < AXIS_SLOP && Math.abs(dy) < AXIS_SLOP) { return false; }
      d.axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      if (d.axis === 'y') { return false; }
      d.active = true;
      this.stage.classList.add('is-dragging');
    }

    d.samples.push({ x: x, t: Date.now() });
    if (d.samples.length > 8) { d.samples.shift(); }

    this.pos = d.pos0 - dx / this.slideWidth();
    this.layout(false);
    return true;
  };

  OmrCoverflow.prototype.dragEnd = function (x, cancelled) {
    var d = this.drag;
    this.drag = null;
    if (!d || !d.active) { return; }

    this.stage.classList.remove('is-dragging');
    this.clickBlockedUntil = Date.now() + CLICK_GUARD_MS;

    var sw = this.slideWidth();
    var dx = x - d.x0;

    /* Velocidad en los ultimos ~100 ms (px/ms, con signo). */
    var now = Date.now();
    var ref = d.samples[0];
    for (var i = d.samples.length - 1; i >= 0; i--) {
      ref = d.samples[i];
      if (now - ref.t >= 100) { break; }
    }
    var dt = Math.max(1, now - ref.t);
    var v = cancelled ? 0 : (x - ref.x) / dt;

    var base = Math.round(d.pos0);
    var target = Math.round(this.pos - (v * FLICK_MS) / sw);

    /* Un arrastre corto pero deliberado tambien cambia de tarjeta. */
    if (target === base && !cancelled && Math.abs(dx) > sw * TAP_STEP) {
      target = base + (dx < 0 ? 1 : -1);
    }
    target = Math.max(base - MAX_JUMP, Math.min(base + MAX_JUMP, target));

    this.pos = mod(target, this.slides.length);
    this.layout(true);
  };

  OmrCoverflow.prototype.bind = function () {
    var self = this;
    var stage = this.stage;

    /* Flechas visibles (opcionales). */
    if (this.prevBtn) { this.prevBtn.addEventListener('click', function () { self.go(-1); }); }
    if (this.nextBtn) { this.nextBtn.addEventListener('click', function () { self.go(1); }); }

    /* Teclado: flechas con el foco dentro del componente. */
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(-1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { self.go(1); e.preventDefault(); }
    });

    /* ---- Tactil: eventos touch. Los listeners son pasivos: el eje vertical lo cede el
       CSS (touch-action: pan-y), asi la pagina sigue haciendo scroll con normalidad. ---- */
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { self.dragEnd(0, true); return; }
      self.dragStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) { return; }
      self.dragMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      self.dragEnd(t ? t.clientX : (self.drag ? self.drag.x0 : 0), false);
    }, { passive: true });
    stage.addEventListener('touchcancel', function () {
      self.dragEnd(self.drag ? self.drag.x0 : 0, true);
    }, { passive: true });

    /* ---- Raton / lapiz: eventos pointer, SOLO mouse y pen. El touch ya lo cubre arriba;
       atenderlo aqui tambien lo contaria dos veces. Sin setPointerCapture: capturar
       redirige el click al escenario y rompe los enlaces de las tarjetas. ---- */
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') { return; }
      if (e.button !== 0) { return; }
      self.mouseId = e.pointerId;
      self.dragStart(e.clientX, e.clientY);
    });
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || self.mouseId !== e.pointerId || !self.drag) { return; }
      self.dragMove(e.clientX, e.clientY);
    });
    var pointerEnd = function (e) {
      if (e.pointerType === 'touch' || self.mouseId !== e.pointerId) { return; }
      self.mouseId = null;
      self.dragEnd(e.clientX, e.type === 'pointercancel');
    };
    window.addEventListener('pointerup', pointerEnd);
    window.addEventListener('pointercancel', pointerEnd);

    /* Un arrastre no debe abrir la ficha del producto. */
    stage.addEventListener('click', function (e) {
      if (Date.now() < self.clickBlockedUntil) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---- Trackpad: dos dedos en horizontal llegan como wheel con deltaX. ----
       Un gesto = una tarjeta: tras pasar una, se ignora el resto de la inercia hasta que
       el trackpad deja de mandar eventos. El scroll vertical no se toca. */
    this.root.addEventListener('wheel', function (e) {
      var ax = Math.abs(e.deltaX);
      var ay = Math.abs(e.deltaY);
      if (ax < 1 || ax <= ay) { return; }

      e.preventDefault(); /* tambien evita el "atras" del navegador por deslizar */

      var now = Date.now();
      if (now - self.wheelLast > WHEEL_GAP) {
        self.wheelAcc = 0;
        self.wheelLocked = false;
      }
      self.wheelLast = now;
      if (self.wheelLocked) { return; }

      self.wheelAcc += e.deltaX;
      if (Math.abs(self.wheelAcc) >= WHEEL_STEP) {
        self.go(self.wheelAcc > 0 ? 1 : -1);
        self.wheelAcc = 0;
        self.wheelLocked = true;
      }
    }, { passive: false });
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-omr-coverflow]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__omrCoverflow) {
        roots[i].__omrCoverflow = new OmrCoverflow(roots[i]);
      }
    }
  }

  window.OmrCoverflow = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* Editor de temas: la seccion se vuelve a pintar al cambiar un setting. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
